import {Typography, useTheme} from '@mui/material'

export const AlpinistTitle: React.FC = () => {
  const theme = useTheme()

  return (
    <Typography
      sx={{
        fontWeight: 800,
        letterSpacing: 0.5,
        userSelect: 'none',
        background: theme.palette.background.aiGradient,
        WebkitBackgroundClip: 'text',
        WebkitTextFillColor: 'transparent',
        lineHeight: 1.2,
        whiteSpace: 'nowrap',
      }}
    >
      Alpinist
    </Typography>
  )
}
